export default __webpack_public_path__ + "static/media/img1.48af8794.jpg";